import { render, staticRenderFns } from "./message_manage.vue?vue&type=template&id=dba7a346&scoped=true"
import script from "./message_manage.vue?vue&type=script&lang=js"
export * from "./message_manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba7a346",
  null
  
)

export default component.exports